import {
  createCHeliPlayerInfoFromChannelSessionDetail,
  type CHeliPlayerInfo
} from './CHeliPlayerInfo';

import type {IHeliNetError} from './IHeliNetError';
import type {LiveChannelDetail} from '../types/network';

export class CHeliLiveChannel implements IHeliNetError {
  #errorCode: string | null = null;
  #errorData: unknown = null;
  #detail: LiveChannelDetail | null;

  constructor(detail: LiveChannelDetail | null) {
    this.#detail = detail;
  }

  getErrorCode(): string | null {
    return this.#errorCode;
  }
  getErrorData(): unknown {
    return this.#errorData;
  }
  setError({code, data}: {code: string | null; data: unknown}) {
    this.#errorCode = code;
    this.#errorData = data;
  }
  isValid() {
    return this.#errorCode === null && this.#errorData === null;
  }

  getChannelId(): string | null {
    return this.#detail?.channel_id ?? null;
  }

  getValue<T extends keyof LiveChannelDetail>(key: T) {
    if (this.#detail) {
      return this.#detail[key];
    }
    return null;
  }

  async refresh() {
    if (!this.#detail?.channel_id) {
      this.setError({code: '400', data: 'm_channelId is null'});
      return false;
    }
    try {
      const result = await globalThis.heliport.v3.api.channelSessionApi.fetchLiveChannelDetail(
        this.#detail.channel_id
      );
      if (result.status !== 'ok') {
        this.setError({
          code: 'errorCode' in result ? result.errorCode : result.code,
          data: result.data
        });
        return false;
      }
      const liveChannelDetail = result.data.live_channel;
      this.#detail = liveChannelDetail as LiveChannelDetail;
      return true;
    } catch (error) {
      this.setError({code: '400', data: error});
      return false;
    }
  }

  async getPlayerList(): Promise<CHeliPlayerInfo[]> {
    const updateResult = await this.refresh();
    if (updateResult && this.#detail && this.#detail.channel_sessions) {
      return this.#detail.channel_sessions.map(createCHeliPlayerInfoFromChannelSessionDetail);
    } else {
      return [];
    }
  }
}
